import Footer from "./Footer"
import "./../style/impressum.css"


export default function Impressum(){
    
    const bodyText = (
    <div className="ce-bodytext">
        <p><strong>Angaben gemäß § 5 TMG</strong></p>
        <p>
            Universitätsklinikum Freiburg
            Breisacher Straße 153
            D 79110 Freiburg
            <strong>Das Universitätsklinikum Freiburg</strong>
            &nbsp;ist eine rechtsfähige Anstalt des öffentlichen Rechts der Albert-Ludwigs-Universität Freiburg.
            <strong>Vertreten durch:</strong>
            <strong>Vorstand:</strong>
            Leitender Ärztlicher Direktor: Prof. Dr. Dr. h.c. Frederik Wenz (Vorsitz)
            Kaufmännische Direktorin: Anja Simon
            Stellvertretender Leitender Ärztlicher Direktor: Prof. Dr. Dr. Rainer Schmelzeisen
            Dekan der Medizinischen 
            Fakultät: Prof. Dr. Lutz Hein
            Pflegedirektor: Helmut Schiffer
            <strong>Aufsichtsrat:</strong>
            Vorsitzender: Dr. Carsten Dose
            Stellvertretender Vorsitzender: Rektorin Prof. Dr. Kerstin Krieglstein
        </p>
        <p>
            <strong>Kontakt:</strong>
            Telefon: +49 761 270-0
            E-Mail:info@uniklinik-freiburg.de
        </p>
        <p>
            <strong>Umsatzsteuer:</strong>
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
            DE 811506626
        </p>
        <p>
            <strong>Aufsichtsbehörde:</strong>
            Name: Ministerium für Wissenschaft, Forschung und Kunst
            Anschrift: Königstraße 46, 70173 Stuttgart
            Link: 
            <a href="https://mwk.baden-wuerttemberg.de/" title="Öffnet Link in neuem Browser-Fenster" target="_blank" rel="noreferrer 
                nofollow">https://mwk.baden-wuerttemberg.de/
            </a>
        </p>
        <p>
            <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong>
            Benjamin Waschow, Leiter Stabsstelle Unternehmenskommunikation
            Breisacher Straße 153
            D 79110 Freiburg
        </p>
        <p>
        <strong>Angaben zur Berufshaftpflichtversicherung</strong>
        Name und Sitz des Versicherers: HDI Global SE, Riethorst 4, 30659 Hannover
        Räumliche Geltung: 
        Deutschland
        </p>
        <p>
            <strong>Haftung für Inhalte</strong>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
            Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der 
            Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer 
            konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </p>
        <p>
            <strong>Haftung für Links</strong>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden 
            Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten 
            Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. 
            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. 
            Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>
        <p>
            <strong>Urheberrecht</strong>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. 
            Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des 
            jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf 
            dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. 
            Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden 
            wir derartige Inhalte umgehend entfernen.
        </p>
        <p>
            <strong>Barrierefreiheit der Internetseite</strong>
            Bei der Gestaltung der Seiten des Universitätsklinikums 
            Freiburg wurde besonderer Wert auf klar und deutlich strukturierte Informationen, eine kontrastreiche Darstellung der Texte sowie der Navigations- 
            und Bedienelemente gelegt. Die Semantik des HTML erfolgt in strikter Trennung von Inhalt, Struktur und Design. Überschriften werden so gewählt, 
            dass sie auch für die Struktur aussagekräftig sind.
        </p> 
        <p>
            <strong>- Anpassung der Schriftgrößen</strong>
            Über die Tastenkombination Strg+ (vergrößern) und Strg- 
            (verkleinern) lässt sich die Schriftgröße an die persönlichen Bedürfnisse des Nutzers anpassen. Zur Ausgangsgröße gelangt man wieder mit STRG 0. 
            Die korrekte Darstellung der Website wurde auf verschiedenen Browsern sowie älteren Browserversionen getestet. &nbsp;
        </p>
        <p>
            <strong>- Optimierung für mobile Endgeräte</strong>
            Die Website ist „responsive“ und wird für die Darstellung auf mobilen Geräten wie Tablet-PCs und Smartphones automatisch angepasst. 
            Alle Inhalte des normalen Webauftritts sind auf diesen Geräten ebenfalls sichtbar. 
            Zusätzlich bieten wir Smartphone-Nutzern an, dass angezeigte Telefonnummern direkt ausgewählt und angerufen werden können sowie ausgewählte 
            E-Mail-Adressen automatisch in das Adressfeld eines neuen E-Mail-Fensters übertragen werden. 
        </p>
        
        <p>
            <strong>- Nutzbarkeit durch Screenreader</strong>
            Die Seite des Universitätsklinikums Freiburg wurde so programmiert, dass Screenreader die Seitenstruktur der meisten Unterseiten erkennen. 
            Links und Formulare sind als solche gekennzeichnet. Screenreader gehören zu den speziellen Ausgabegeräten, die vor allem blinden Menschen die 
            Navigation durch eine Website ermöglichen. Mithilfe des Screenreaders können dem Nutzer Inhalte über einen Lautsprecher vorgelesen werden.
        </p>
        <p>
            <strong>- Stand der Vereinbarkeit mit den Anforderungen</strong>
            Die Websites sind mit den Richtlinien des Europäischen Parlaments und des 
            Rates über den barrierefreien Zugang zu den Websites und mobilen Anwendungen öffentlicher Stellen (2016/2102) noch nicht vollständig vereinbar. 
            Die Unvereinbarkeiten und noch nicht barrierefreien Inhalte sind nachstehend aufgeführt.
        </p>
        <ul>
            <li>PDF-Dokumente konnten noch nicht auf ein barrierefreies Format umgestellt werden.</li>
            <li>Für eingebundene Videos stehen derzeit zum Teil keine Untertitel oder Transkription zur Verfügung.</li>
            <li>In den Seiten enthaltene Grafiken oder Bilder sind derzeit noch nicht vollständig durch Textbeschreibungen ergänzt worden.</li>
            <li>In Einzelfällen ist die Navigation nicht ohne Maus möglich.</li>
        </ul>
    </div>)




    return (
    <div className="flex flex-column impressum ">
        <div className="frame frame-type-textpic frame-layout-0 frame-space-before-none frame-space-after-medium frame-padding-top-none frame-padding-bottom-none  
            frame-d-flex d-sm-flex d-md-flex d-lg-flex d-xl-flex d-xxl-flex 
            mb-6 " 
            id="c82 ">
            <div className="container">
                <div className="ce-content">
                    <div className="ce-header h2-mb ce-header-left">
                        <div className="ce-headline">
                            <h2 className="">Impressum</h2>
                        </div>
                    </div>
                        
                    <div className="row layout-100g-100t">
                        <div className=" d-block col-12 d-sm-block col-sm-12 d-md-block col-md-12 d-lg-block col-lg-12 d-xl-block col-xl-12 d-xxl-block 
                            col-xxl-12 column-0 col-type-media" id="c82-c0">
                        </div>
                        <div className=" d-block col-12 d-sm-block col-sm-12 d-md-block col-md-12 d-lg-block col-lg-12 
                            d-xl-block col-xl-12 d-xxl-block col-xxl-12 column-1" id="c82-c1">
                            {bodyText}
                        </div>
                    </div>
                    <div className="frame frame-type-textpic frame-layout-0 frame-space-before-none frame-space-after-medium frame-padding-top-none frame-padding-bottom-none  
                    frame-d-flex d-sm-flex d-md-flex d-lg-flex d-xl-flex d-xxl-flex" id="c2170">
                        <div className="container">
                            <div className="ce-content">
                                <div className="row layout-100g-100t">
                                    <div className=" d-block col-12 d-sm-block col-sm-12 d-md-block col-md-12 d-lg-block col-lg-12 d-xl-block col-xl-12 d-xxl-block col-xxl-12 
                                    column-1" id="c2170-c1">
                                        <div className="ce-bodytext nextprev-button-wrapper">
                                            <div className="turn align-right"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <Footer />
    </div>

        
    )
}